import React from 'react';

const SVG = ({ style = {}, mode, color = 'red', width = '100%', viewBox = '0 0 100 100' }) => (
  <svg style={{ ...style, display: 'block' }} width={width} height={width} viewBox={viewBox} xmlns="http://www.w3.org/2000/svg">
    <g id="tile" stroke={color} strokeWidth="14" fill="none">
      <line x2="100" y2="100" />
      <line x1="100" y2="100" />
    </g>
  </svg>
);

export default SVG;
